import { render, staticRenderFns } from "./IconThumbUp.vue?vue&type=template&id=aaaf2038"
import script from "./IconThumbUp.vue?vue&type=script&lang=js"
export * from "./IconThumbUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports